/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as AuthImport } from './routes/_auth'
import { Route as AppImport } from './routes/_app'
import { Route as IndexImport } from './routes/index'
import { Route as AuthSignupImport } from './routes/_auth/signup'
import { Route as AuthResetPasswordImport } from './routes/_auth/resetPassword'
import { Route as AuthLoginImport } from './routes/_auth/login'
import { Route as AuthForgotPasswordImport } from './routes/_auth/forgotPassword'
import { Route as AppVisasIndexImport } from './routes/_app/visas/index'
import { Route as AppUsersIndexImport } from './routes/_app/users/index'
import { Route as AppTransactionsIndexImport } from './routes/_app/transactions/index'
import { Route as AppSendIndexImport } from './routes/_app/send/index'
import { Route as AppProfileIndexImport } from './routes/_app/profile/index'
import { Route as AppPassengersIndexImport } from './routes/_app/passengers/index'
import { Route as AppFlightsIndexImport } from './routes/_app/flights/index'
import { Route as AppDashboardIndexImport } from './routes/_app/dashboard/index'
import { Route as AppCollectionsIndexImport } from './routes/_app/collections/index'
import { Route as AppCardsIndexImport } from './routes/_app/cards/index'
import { Route as AppAccommodationIndexImport } from './routes/_app/accommodation/index'
import { Route as AppTransactionsIdImport } from './routes/_app/transactions/$id'
import { Route as AppSendSuccessImport } from './routes/_app/send/success'
import { Route as AppSendReviewImport } from './routes/_app/send/review'
import { Route as AppSendConfirmImport } from './routes/_app/send/confirm'
import { Route as AppSendBeneficiaryImport } from './routes/_app/send/beneficiary'

// Create/Update Routes

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const AppRoute = AppImport.update({
  id: '/_app',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AuthSignupRoute = AuthSignupImport.update({
  path: '/signup',
  getParentRoute: () => AuthRoute,
} as any)

const AuthResetPasswordRoute = AuthResetPasswordImport.update({
  path: '/resetPassword',
  getParentRoute: () => AuthRoute,
} as any)

const AuthLoginRoute = AuthLoginImport.update({
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)

const AuthForgotPasswordRoute = AuthForgotPasswordImport.update({
  path: '/forgotPassword',
  getParentRoute: () => AuthRoute,
} as any)

const AppVisasIndexRoute = AppVisasIndexImport.update({
  path: '/visas/',
  getParentRoute: () => AppRoute,
} as any)

const AppUsersIndexRoute = AppUsersIndexImport.update({
  path: '/users/',
  getParentRoute: () => AppRoute,
} as any)

const AppTransactionsIndexRoute = AppTransactionsIndexImport.update({
  path: '/transactions/',
  getParentRoute: () => AppRoute,
} as any)

const AppSendIndexRoute = AppSendIndexImport.update({
  path: '/send/',
  getParentRoute: () => AppRoute,
} as any)

const AppProfileIndexRoute = AppProfileIndexImport.update({
  path: '/profile/',
  getParentRoute: () => AppRoute,
} as any)

const AppPassengersIndexRoute = AppPassengersIndexImport.update({
  path: '/passengers/',
  getParentRoute: () => AppRoute,
} as any)

const AppFlightsIndexRoute = AppFlightsIndexImport.update({
  path: '/flights/',
  getParentRoute: () => AppRoute,
} as any)

const AppDashboardIndexRoute = AppDashboardIndexImport.update({
  path: '/dashboard/',
  getParentRoute: () => AppRoute,
} as any)

const AppCollectionsIndexRoute = AppCollectionsIndexImport.update({
  path: '/collections/',
  getParentRoute: () => AppRoute,
} as any)

const AppCardsIndexRoute = AppCardsIndexImport.update({
  path: '/cards/',
  getParentRoute: () => AppRoute,
} as any)

const AppAccommodationIndexRoute = AppAccommodationIndexImport.update({
  path: '/accommodation/',
  getParentRoute: () => AppRoute,
} as any)

const AppTransactionsIdRoute = AppTransactionsIdImport.update({
  path: '/transactions/$id',
  getParentRoute: () => AppRoute,
} as any)

const AppSendSuccessRoute = AppSendSuccessImport.update({
  path: '/send/success',
  getParentRoute: () => AppRoute,
} as any)

const AppSendReviewRoute = AppSendReviewImport.update({
  path: '/send/review',
  getParentRoute: () => AppRoute,
} as any)

const AppSendConfirmRoute = AppSendConfirmImport.update({
  path: '/send/confirm',
  getParentRoute: () => AppRoute,
} as any)

const AppSendBeneficiaryRoute = AppSendBeneficiaryImport.update({
  path: '/send/beneficiary',
  getParentRoute: () => AppRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_app': {
      preLoaderRoute: typeof AppImport
      parentRoute: typeof rootRoute
    }
    '/_auth': {
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/_auth/forgotPassword': {
      preLoaderRoute: typeof AuthForgotPasswordImport
      parentRoute: typeof AuthImport
    }
    '/_auth/login': {
      preLoaderRoute: typeof AuthLoginImport
      parentRoute: typeof AuthImport
    }
    '/_auth/resetPassword': {
      preLoaderRoute: typeof AuthResetPasswordImport
      parentRoute: typeof AuthImport
    }
    '/_auth/signup': {
      preLoaderRoute: typeof AuthSignupImport
      parentRoute: typeof AuthImport
    }
    '/_app/send/beneficiary': {
      preLoaderRoute: typeof AppSendBeneficiaryImport
      parentRoute: typeof AppImport
    }
    '/_app/send/confirm': {
      preLoaderRoute: typeof AppSendConfirmImport
      parentRoute: typeof AppImport
    }
    '/_app/send/review': {
      preLoaderRoute: typeof AppSendReviewImport
      parentRoute: typeof AppImport
    }
    '/_app/send/success': {
      preLoaderRoute: typeof AppSendSuccessImport
      parentRoute: typeof AppImport
    }
    '/_app/transactions/$id': {
      preLoaderRoute: typeof AppTransactionsIdImport
      parentRoute: typeof AppImport
    }
    '/_app/accommodation/': {
      preLoaderRoute: typeof AppAccommodationIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/cards/': {
      preLoaderRoute: typeof AppCardsIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/collections/': {
      preLoaderRoute: typeof AppCollectionsIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/dashboard/': {
      preLoaderRoute: typeof AppDashboardIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/flights/': {
      preLoaderRoute: typeof AppFlightsIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/passengers/': {
      preLoaderRoute: typeof AppPassengersIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/profile/': {
      preLoaderRoute: typeof AppProfileIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/send/': {
      preLoaderRoute: typeof AppSendIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/transactions/': {
      preLoaderRoute: typeof AppTransactionsIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/users/': {
      preLoaderRoute: typeof AppUsersIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/visas/': {
      preLoaderRoute: typeof AppVisasIndexImport
      parentRoute: typeof AppImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren([
  IndexRoute,
  AppRoute.addChildren([
    AppSendBeneficiaryRoute,
    AppSendConfirmRoute,
    AppSendReviewRoute,
    AppSendSuccessRoute,
    AppTransactionsIdRoute,
    AppAccommodationIndexRoute,
    AppCardsIndexRoute,
    AppCollectionsIndexRoute,
    AppDashboardIndexRoute,
    AppFlightsIndexRoute,
    AppPassengersIndexRoute,
    AppProfileIndexRoute,
    AppSendIndexRoute,
    AppTransactionsIndexRoute,
    AppUsersIndexRoute,
    AppVisasIndexRoute,
  ]),
  AuthRoute.addChildren([
    AuthForgotPasswordRoute,
    AuthLoginRoute,
    AuthResetPasswordRoute,
    AuthSignupRoute,
  ]),
])

/* prettier-ignore-end */
